import React, { useState, useEffect, useContext } from 'react'
import { Table } from '../../dpe-usco/components/Table/Table'
import Widget from '../../dpe-usco/components/Widget/Widget'
import HeaderFilter from '../../components/subComponents/HeaderFilter'
import { Button } from 'syngenta-react-components'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { GlobalContext } from '../../services/context'


const StewardshipTable = ({ data, status }) => {
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    setTableData(data)
  }, [data])
  const ascend = () => {
    const ascendedData = [...tableData]
    ascendedData.sort((a, b) => {
      return a.contract_name > b.contract_name ? 1 : -1
    })

    setTableData(() => {
      return ascendedData
    })
  }

  const descend = () => {
    const descendedData = [...tableData]
    descendedData.sort((a, b) => {
      return a.contract_name < b.contract_name ? 1 : -1
    })
    setTableData(() => {
      return descendedData
    })
  }

  const headerCell = value => {
    const sortFunction = () => {
      return
    }
    return (
      <div key={value} className='cell df aic' onClick={sortFunction}>
        <span>{value}</span>
        <HeaderFilter ascend={ascend} descend={descend} />
      </div>
    )
  }

  const structure = {
    headers: [
      {
        value: 'Year',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Grower',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: 'Receiver',
        format() {
          return headerCell(this.value)
        }
      },
      {
        value: ' ',
        format() {
          return ( 
            <div key='space' className='cell df aic'>
              <span>{this.value}</span>
            </div>
          )
        }
      }
    ],
    dataKeys: [
      'harvestYear',
      'growerName',
      'grainReceiver',
      'stewardshipActiveID'
    ],
    rowFormat: {
      stewardshipActiveID: {
        format: id => {
          return (
            <div className='mt10 fz-15' data-testid='viewStewardshipButton'>
              <Button
                type='success'
                text='View'
                onClick={e => {
                  e.preventDefault()
                  let selected = tableData.filter(obj => obj.stewardshipActiveID === id)
                  const company_id = selected[0].external_reference_id
                  trackEvent('view_stewardship_clicked', {
                    from: 'contractDashboard',
                    companyId: company_id,
                    stewardshipActivityId: selected[0].stewardshipActiveID
                  })
                  dispatch({ 
                    type: 'GO_TO_STEWARDSHIP_DETAIL', 
                    payload: { stewardship_activity_id: id, company_id, detailView: { previous: 'Stewardship', title: `${selected[0].contractYear}: ${selected[0].growerName} to ${selected[0].grainReceiver}`, id: selected[0].stewardshipActiveID , new_contract_id: selected[0].new_contract_id } } })
                }}
              ></Button>
            </div>
          )
        }
      }
    }
  }
  return (
    <Widget dataTestId='stewardshipTable' title={'Stewardship'}>
      <Table data={tableData} structure={structure} statusComponent={status ? <TableStatus status={status}/> : null}></Table>
    </Widget>
  )
}

export default StewardshipTable